import { render } from "@/components/webPhone/template/phone.html?vue&type=template&id=38ee25bc&scoped=true"
import script from "./phone.vue?vue&type=script&lang=js"
export * from "./phone.vue?vue&type=script&lang=js"

import "./phone.vue?vue&type=style&index=0&id=38ee25bc&scoped=true&lang=css"

import exportComponent from "/Users/garay/code/omnichannel/dashboard-agente/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ee25bc"]])

export default __exports__